<template>
    <div class="container" id="enrollment">
        <div class="faqs-card" v-for="(faq, index) in faqs" :key="index">
            <div v-if="faq.category_id == list">
                <h5 class="faqs-card-title"">
                    {{ faq.title[locale] }}
                </h5>
                <p class="faqs-card-text" v-html="faq.description[locale]">
                    {{ faq.description[locale] }}
                </p>
                <div class="faqs-card-line"></div>
            </div>
        </div>
        <div
            v-if="
                !Object.entries(categories).length ||
                    !Object.entries(faqs).length
            "
        >
            {{ $trans.get("faqs.no_questions") }}
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            locale: window.appLocale
        };
    },
    watch: {
        faqs() {
            console.log(this.faqs);
        }
    },
    props: {
        faqs: Array,
        list: Number,
        categories: { type: Array, default: () => null }
    }
};
</script>
